<template>
  <div v-if="travelDetails">
    <div class="row items-center q-py-sm" style="background: #3BA46A">
      <i class="ri-time-fill q-px-md" style="color: #fff; font-size: 20px"></i>
      <div class="column">
        <span style="color: #fff; font-weight: 600">DESEMBARQUE EM ANDAMENTO</span>
        <span style="color: #fff">
          Iniciado por:
          <b class="text-capitalize">{{ nameUser }}</b>
        </span>
      </div>
    </div>
    <q-separator></q-separator>
    <div class="travel__schedule">
      <div class="schedule__info">
        <div class="row q-py-sm">
          <div class="text-caption text-weight-bold">{{ cityToCamelCase(travelDetails.travel_origin) }}</div>
          <q-icon name="arrow_forward" class="q-mx-sm" style="color: #3BA46A; font-size: 1.5em" />
          <div class="text-caption text-weight-bold">{{ cityToCamelCase(travelDetails.travel_destiny) }}</div>
        </div>
        <div class="info__bus">
          <q-icon name="directions_bus" style="font-size: 20px" />

          <div class="text-uppercase text-caption">
            Carro
            <span class="info__bus--color">{{ travelDetails.number_bus }}</span>
          </div>
        </div>
      </div>

      <q-separator inset />
    </div>

    <div class="disembark">
      <div class="column q-px-md q-py-sm">
        <span style="color: #7a8583; font-size: 10px">
          Saída dia
          <span class="text-weight-bold" v-if="travelDetails.departure_date">
            {{ travelDetails.departure_date.split("T")[0].split("-").reverse().join("/") + " " + travelDetails.departure_time.slice(0, -3) }}
          </span>
        </span>
        <span style="color: #7a8583; font-size: 10px">
          Saída da agência
          <span class="text-weight-bold">{{ travelDetails.departure_datetime | formatDate }}</span>
        </span>
      </div>
    </div>

    <div v-if="travelDetails.passengers" class="passengers__history">
      <div style="padding: 20px 20px 20px 20px">
        <span class="text-weight-bold text-black">PASSAGEIROS</span>
      </div>
      <div class="passengers__tips">
        <div class="row">
          <div style="width: 30px; height: 30px; background: #ffe317; border-radius: 5px"></div>
          <div class="q-pt-sm q-pl-xs">- Indica que passageiro ainda não desembarcou.</div>
        </div>
        <div class="row q-pt-xs">
          <div style="width: 30px; height: 30px; background: #3BA46A; border-radius: 5px"></div>
          <div class="q-pt-sm q-pl-xs">- Indica passageiro já desembarcou.</div>
        </div>
      </div>
      <div class="row justify-around q-mt-md">
        <div v-if="mapa.andar_2 && mapa.andar_1">
          Andar 1
          <q-toggle v-model="alterarAndar" true-value="andar_1" false-value="andar_2" color="teal-8" />Andar 2
        </div>
        <div class="q-pt-xs">
          <q-btn no-caps label="Listar passageiros" size="md" color="teal-8" unelevated class="text-weight-bold" @click="dialogListPassengers = true" />
        </div>
      </div>
      <div class="onibus" id="onibus">
        <div class="container-volante">
          <svg
            class="volante"
            width="50px"
            height="50px"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            version="1.1"
            x="0px"
            y="0px"
            viewBox="0 0 100 100"
            enable-background="new 0 0 100 100"
            xml:space="preserve"
          >
            <circle fill="#000" cx="50" cy="53.571" r="7.915" />
            <path
              fill="#000"
              d="M50,0C22.386,0,0,22.386,0,50c0,27.613,22.386,50,50,50c27.613,0,50-22.387,50-50C100,22.386,77.613,0,50,0z M50,8.163c17.871,0,33.115,11.209,39.11,26.977c-0.064,2.236-0.672,4.801-2.994,5.485c-9.949,3.827-18.259-4.401-36.626-4.656 c-18.368,0.255-26.595,8.483-36.543,4.656c-1.653-0.487-2.425-1.927-2.748-3.523C15.637,20.311,31.396,8.163,50,8.163z M60.969,53.571c0,6.059-4.91,10.97-10.969,10.97s-10.969-4.911-10.969-10.97c0-6.058,4.911-10.969,10.969-10.969 S60.969,47.514,60.969,53.571z M20.902,76.531c-1.285,0.584-2.652,0.082-3.928-0.864c-4.667-5.997-7.744-13.291-8.578-21.258 c1.131-1.159,2.91-1.637,5.371-0.838C19.34,55.379,26.515,73.979,20.902,76.531z M64.898,88.777 c-0.338,0.225-0.583,0.425-0.749,0.601c-4.42,1.59-9.182,2.459-14.149,2.459c-5.637,0-11.011-1.123-15.918-3.143 c-5.617-3.789-3.066-7.098-0.281-11.909c2.806-4.847,15.689-3.315,15.689-3.315s12.965-1.531,15.771,3.315 C68.068,81.633,70.682,84.953,64.898,88.777z M85.326,72.402c-1.847,2.36-4.619,5.253-7.095,4.129 c-5.611-2.552,1.568-21.152,7.141-22.96c3.082-0.998,5.093,0,6.104,1.838C90.677,61.601,88.526,67.364,85.326,72.402z"
            />
          </svg>
        </div>

        <div v-for="(linha, index) in mapaAtual" :key="index" class="linha">
          <div v-for="i in 4" :key="i">
            <span
              v-show="linha['ocupada' + i] === false && linha['embarcado' + i] === false"
              :situacao="`${linha['ocupada' + i]}`"
              :embarcado="`${linha['embarcado' + i]}`"
              :numero="linha['coluna' + i]"
              :semafaro="linha['semafaro' + i]"
              :class="`poltrona ${linha['categoria' + i]} ${linha['tipo' + i]} text-black`"
              @click="searchLuggages(searchSeat(linha['coluna' + i]).passage_id, (passengerDetails = searchSeat(linha['coluna' + i])), (dialog = true))"
              >{{ linha["coluna" + i] }}</span
            >

            <span
              v-show="linha['ocupada' + i] === false && linha['embarcado' + i] === true"
              :situacao="`${linha['ocupada' + i]}`"
              :embarcado="`${linha['embarcado' + i]}`"
              :numero="linha['coluna' + i]"
              :semafaro="linha['semafaro' + i]"
              :class="`poltrona ${linha['categoria' + i]} ${linha['tipo' + i]} text-black`"
              @click="searchLuggages(searchSeat(linha['coluna' + i]).passage_id, (passengerDetails = searchSeat(linha['coluna' + i])), (dialog = true))"
              >{{ linha["coluna" + i] }}</span
            >

            <span
              v-show="linha['ocupada' + i] === true"
              :situacao="`${linha['ocupada' + i]}`"
              :embarcado="`${linha['embarcado' + i]}`"
              :numero="linha['coluna' + i]"
              :semafaro="linha['semafaro' + i]"
              :class="`poltrona ${linha['categoria' + i]} ${linha['tipo' + i]} text-black`"
              @click="searchLuggages(searchSeat(linha['coluna' + i]).passage_id, (passengerDetails = searchSeat(linha['coluna' + i])), (dialog = true))"
              >{{ linha["coluna" + i] }}</span
            >

            <span
              v-show="linha['coluna' + i] === undefined"
              :situacao="`${linha['ocupada' + i]}`"
              :embarcado="`${linha['embarcado' + i]}`"
              :numero="linha['coluna' + i]"
              :semafaro="linha['semafaro' + i]"
              :class="`poltrona ${linha['categoria' + i]} ${linha['tipo' + i]} text-black`"
              @click="searchLuggages(searchSeat(linha['coluna' + i]).passage_id, (passengerDetails = searchSeat(linha['coluna' + i])), (dialog = true))"
              >{{ linha["coluna" + i] }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div style="padding: 20px 20px 20px 20px">
        <span class="text-weight-bold text-black">Não existe passageiros com bagagens para desembarque.</span>
      </div>
    </div>

    <q-page-sticky position="bottom-right" :offset="[18, 18]">
      <q-btn @click="readQRCode()" size="lg" class="bg-positive text-white shadow-16" icon="camera_alt" round />
    </q-page-sticky>

    <q-dialog
      v-model="dialog"
      @hide="(luggages = []), (luggageLanding = []), updateLuggageStatus()"
      position="right"
      :maximized="$q.screen.width < 1024 ? true : false"
      style="height: 100vh; max-height: 100vh"
    >
      <q-card style="height: 100vh; max-height: 100vh; width: 100vw">
        <q-card-section class="row items-center">
          <q-space />
          <div class="text-h6 text-bold q-pl-md">DETALHES</div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>
        <q-separator></q-separator>
        <q-card-section class="q-pa-none">
          <div class="manual">
            <div class="manual__info">
              <div class="q-pb-sm" style="font-size: 16px">
                <span class="text-black text-weight-bold text-capitalize">{{ passengerDetails.name }}</span>
                <div>
                  <span>{{ passengerDetails.document_type }}:&nbsp;</span>
                  <span>{{ passengerDetails.document_number }}</span>
                </div>
                <span>Poltrona: {{ passengerDetails.seat }}</span>
              </div>
              <q-separator></q-separator>
              <div class="q-pt-md">
                <div class="row items-center q-pl-xs">
                  <div style="width: 10px; height: 10px; background: #616264; border-radius: 100%" class="shadow-2"></div>
                  <span class="q-pl-sm" style="color: #707070">{{ cityToCamelCase(passengerDetails.boarding_name + "-" + passengerDetails.boarding_uf) }}</span>
                </div>
                <div class="row items-center q-pl-xs q-pb-xs">
                  <div style="width: 10px; height: 10px; background: #3BA46A; border-radius: 100%" class="shadow-2"></div>
                  <span class="q-pl-sm text-weight-bold" style="color: #000000">{{
                    cityToCamelCase(passengerDetails.landing_name + "-" + passengerDetails.landing_uf)
                  }}</span>
                </div>

                <div style="font-size: 13px; color: #7a8583; padding-left: 5px">
                  <span>Saída dia&nbsp;</span>
                  <span class="departure--semi-bold">{{ passengerDetails.departure_travel | formatDate }}</span>
                </div>
                <div style="font-size: 13px; color: #7a8583; padding-left: 5px">
                  <span>Saída da agência&nbsp;</span>
                  <span class="departure--semi-bold">{{ passengerDetails.departure | formatDate }}</span>
                </div>
              </div>
            </div>

            <div style="padding: 20px">
              <q-btn @click="readQRCodeLuggage()" unelevated class="text-white full-width" style="background: #3BA46A; padding: 13px 0">
                <i class="ri-qr-code-line q-pr-sm" style="font-size: 28px"></i>
                <span class="text-weight-bold">Ler QR Code da bagagem</span>
              </q-btn>
            </div>

            <div class="luggage">
              <q-list v-for="(b, index) in luggages" :key="index" class="q-pb-sm">
                <q-card class="luggage__grid items-center no-shadow" style="border-radius: 10px">
                  <div>
                    <i class="ri-suitcase-3-line" style="color: #004923; font-size: 28px"></i>
                  </div>
                  <div class="column" style="line-height: 1.2">
                    <span style="color: #7a8583">Bagagem</span>
                    <span style="color: #da2128">
                      <span class="text-weight-bold">ETIQUETA</span>
                      {{ b.number }}
                    </span>
                  </div>
                  <q-checkbox v-if="b.luggage_delivered === '0'" v-model="luggageLanding" :val="b"></q-checkbox>
                  <span v-else class="text-black text-weight-bold row items-center">
                    BAGAGEM ENTREGUE
                    <i class="ri-check-double-line q-pl-sm" style="font-size: 25px; color: #3BA46A"></i>
                  </span>
                </q-card>
              </q-list>
            </div>
            <div class="fixed-bottom">
              <q-btn
                @click="disembark()"
                no-caps
                unelevated
                label="Desembarcar bagagem selecionada"
                :color="luggageLanding.length === 0 ? 'grey-7' : 'primary'"
                class="full-width q-py-sm text-weight-bold"
                style="font-size: 16px"
              />
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog v-model="dialogListPassengers" position="right" :maximized="$q.screen.width < 1024 ? true : false" style="height: 100vh; max-height: 100vh">
      <q-card style="height: 100vh; max-height: 100vh; width: 100vw">
        <q-card-section class="row items-center">
          <q-space />
          <div class="text-h6 text-bold q-pl-md">LISTA DETALHADA</div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>
        <q-separator></q-separator>
        <q-card-section class="q-pa-none" style="background: #e5e5e5">
          <div class="bg-white q-py-md q-gutter-y-sm">
            <div class="q-px-md">
              <span style="color: #808285">Pesquisa por nome ou poltrona</span>
              <q-input filled v-model="search">
                <template v-slot:prepend>
                  <q-icon name="airline_seat_recline_normal" />
                </template>
              </q-input>
            </div>
            <div class="q-px-md">
              <span style="color: #808285">Pesquisa por cidade desembarque</span>
              <q-select
                filled
                v-model="searchSecc"
                :options="filterSecc"
                :option-value="(v) => (v ? v.code : '')"
                :option-label="(v) => (v ? v.name + '-' + v.uf : '')"
                color="teal-8"
                clearable
                emit-value
                map-options
              >
                <template v-slot:prepend>
                  <q-icon name="location_on" />
                </template>
              </q-select>
            </div>
          </div>
          <q-list v-for="(p, index) in filterByNameOrSeat()" :key="index" style="padding: 10px 20px">
            <q-card class="no-shadow" style="border-radius: 10px">
              <div class="column q-py-sm q-px-md">
                <span class="text-black text-weight-bold">{{ p.name }}</span>
                <span>{{ p.document_type }}: {{ p.document_number }}</span>
                <span>Poltrona: {{ p.seat }}</span>
                <div class="row">
                  <div class="text-caption text-weight-bold">{{ cityToCamelCase(p.boarding_name + "-" + p.boarding_uf) }}</div>
                  <q-icon name="arrow_forward" class="q-mx-sm" style="color: #3BA46A; font-size: 1.5em" />
                  <div class="text-caption text-weight-bold">{{ cityToCamelCase(p.landing_name + "-" + p.landing_uf) }}</div>
                </div>
              </div>
              <q-separator></q-separator>
              <div class="q-py-sm">
                <q-btn @click="searchLuggages(p.passage_id), (passengerDetails = p), (dialog = true)" flat class="row items-center">
                  <i class="ri-suitcase-3-line q-pr-sm" style="font-size: 25px; color: #004923"></i>
                  <span class="text-weight-bold" style="color: #004923">Iniciar desembarque</span>
                </q-btn>
              </div>
            </q-card>
          </q-list>
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog v-model="confirm" @hide="confirmDetails = {}" persistent>
      <q-card>
        <q-card-section class="row items-center" style="display: grid; grid-template-columns: max-content 1fr">
          <i class="ri-suitcase-3-line" style="color: #808285; font-size: 30px"></i>
          <span class="q-ml-md" style="font-size: 15px">
            Você deseja prosseguir com desembarque da bagagem de código:
            <span class="text-weight-bold text-black">{{ confirmDetails.number }}</span>
          </span>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn no-caps flat label="Cancelar" color="red" v-close-popup />
          <q-btn no-caps @click="disembarkQrCode(confirmDetails)" unelevated label="Confirmar desembarque" color="primary" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { mutations } from "../store";
import { formatDate, getHost, URIToObject } from "../functions";
import { getLocalStorage, cityToCamelCase, setLocalStorage } from "../functions";
import { DISEMBARK_LIST, USER_ID, USER } from "../variables";
import moment from "moment";
export default {
  name: "DisembarkPassengers",
  computed: {
    nameUser: {
      get() {
        return getLocalStorage(USER).split(" ")[0].toLowerCase();
      },
    },
    filterSecc: {
      get() {
        let secc = [];
        for (const i in this.travelDetails.passengers) {
          if (secc.filter((v) => this.travelDetails.passengers[i].landing_code === v.code).length === 0)
            secc.push({
              code: this.travelDetails.passengers[i].landing_code,
              name: this.travelDetails.passengers[i].landing_name,
              uf: this.travelDetails.passengers[i].landing_uf,
            });
        }
        return secc;
      },
    },
  },
  filters: {
    formatDate,
  },
  created() {
    this.travelDetails = getLocalStorage(DISEMBARK_LIST) ? getLocalStorage(DISEMBARK_LIST) : [];
    this.updateLuggageStatus();
  },
  mounted() {
    mutations.setHeaderTitle("Desembarque " + this.travelDetails.landing_name + "-" + this.travelDetails.landing_uf);
  },
  data() {
    return {
      travelDetails: [],
      dialog: false,
      dialogListPassengers: false,
      search: "",
      searchSecc: "",
      passengerDetails: {},
      luggages: null,
      luggageLanding: [],
      confirm: false,
      confirmDetails: {},
      mapa: [],
      mapaAtual: [],
      alterarAndar: "andar_1",
    };
  },
  watch: {
    alterarAndar: function () {
      this.mapaAtual = this.mapa[this.alterarAndar];
    },
  },
  methods: {
    cityToCamelCase,
    updateLuggageStatus() {
      let structHistory = {
        travel_id: this.travelDetails.travel_id,
        secc_place: this.travelDetails.boarding_code,
      };
      window.http.get(`${getHost()}/eucaturmobile/disembark`, structHistory).then((r) => {
        setLocalStorage(DISEMBARK_LIST, r.data);
        this.travelDetails = r.data;
        this.getMapa();
      });
    },
    async getMapa() {
      const destino = this.travelDetails.lading_code;
      const origem = this.travelDetails.boarding_code;
      const travel_id = this.travelDetails.travel_id;

      const departure = formatDate(this.travelDetails.departure).substring(10, 0);

      const r = await window.http.get(`${getHost()}/eucaturmobile/viagens/${travel_id}/mapa?embarque=${origem}&desembarque=${destino}&data=${departure}`);
      this.mapa = r.data;
      this.mapaAtual = r.data.andar_1;
      this.makeMapa();
    },
    makeMapa() {
      if (this.mapa.andar_1) {
        for (let r of this.mapa.andar_1) {
          if (r.coluna1) {
            r.ocupada1 = true;
            let col1 = this.searchSeat(r.coluna1);
            if (col1) {
              r.ocupada1 = false;
              if (col1.have_luggage_deliver) {
                r.embarcado1 = true;
              } else {
                r.embarcado1 = false;
              }
            }
          }
          if (r.coluna2) {
            r.ocupada2 = true;
            let col2 = this.searchSeat(r.coluna2);
            if (col2) {
              r.ocupada2 = false;
              if (col2.have_luggage_deliver) {
                r.embarcado2 = true;
              } else {
                r.embarcado2 = false;
              }
            }
          }
          if (r.coluna3) {
            r.ocupada3 = true;
            let col3 = this.searchSeat(r.coluna3);
            if (col3) {
              r.ocupada3 = false;
              if (col3.have_luggage_deliver) {
                r.embarcado3 = true;
              } else {
                r.embarcado3 = false;
              }
            }
          }
          if (r.coluna4) {
            r.ocupada4 = true;
            let col4 = this.searchSeat(r.coluna4);
            if (col4) {
              r.ocupada4 = false;
              if (col4.have_luggage_deliver) {
                r.embarcado4 = true;
              } else {
                r.embarcado4 = false;
              }
            }
          }
        }
      }
      if (this.mapa.andar_2) {
        for (let r of this.mapa.andar_2) {
          if (r.coluna1) {
            r.ocupada1 = true;
            let col1 = this.searchSeat(r.coluna1);
            if (col1) {
              r.ocupada1 = false;
              if (col1.have_luggage_deliver) {
                r.embarcado1 = true;
              } else {
                r.embarcado1 = false;
              }
            }
          }
          if (r.coluna2) {
            r.ocupada2 = true;
            let col2 = this.searchSeat(r.coluna2);
            if (col2) {
              r.ocupada2 = false;
              if (col2.have_luggage_deliver) {
                r.embarcado2 = true;
              } else {
                r.embarcado2 = false;
              }
            }
          }
          if (r.coluna3) {
            r.ocupada3 = true;
            let col3 = this.searchSeat(r.coluna3);
            if (col3) {
              r.ocupada3 = false;
              if (col3.have_luggage_deliver) {
                r.embarcado3 = true;
              } else {
                r.embarcado3 = false;
              }
            }
          }
          if (r.coluna4) {
            r.ocupada4 = true;
            let col4 = this.searchSeat(r.coluna4);
            if (col4) {
              r.ocupada4 = false;
              if (col4.have_luggage_deliver) {
                r.embarcado4 = true;
              } else {
                r.embarcado4 = false;
              }
            }
          }
        }
      }
    },
    searchSeat(seat) {
      if (this.travelDetails.passengers) {
        for (let v of this.travelDetails.passengers) {
          if (v.seat == seat) {
            return v;
          }
        }
      }
    },
    disembark() {
      for (const v of this.luggageLanding) {
        v.offline = false;
        v.user_id = getLocalStorage(USER_ID);
        v.datetime = moment().format();
        window.http.put(`${getHost()}/eucaturmobile/disembark`, v).then((r) => {
          if (r.status === 200) {
            mutations.openAlert({
              open: true,
              message: "Bagagem " + v.number + " desembarcada",
              status: 200,
            });
            this.searchLuggages(this.passengerDetails.passage_id);
          }
        });
      }
    },
    disembarkQrCode(value) {
      value.offline = false;
      value.user_id = getLocalStorage(USER_ID);
      value.datetime = moment().format();
      window.http.put(`${getHost()}/eucaturmobile/disembark`, value).then((r) => {
        if (r.status === 200) {
          mutations.openAlert({
            open: true,
            message: "Bagagem " + value.number + " desembarcada",
            status: 200,
          });
          this.searchLuggages(this.passengerDetails.passage_id);
        }
      });
    },
    funcTrim(value) {
      return value.trim();
    },
    filterByNameOrSeat() {
      if (this.search || this.searchSecc) {
        return this.travelDetails.passengers.filter((v) => {
          if (this.search) {
            return v.name.toLowerCase().includes(this.search.toLowerCase()) || v.seat === this.search;
          } else if (this.searchSecc) {
            return v.landing_code == this.searchSecc;
          }
        });
      } else {
        return this.travelDetails.passengers;
      }
    },
    searchLuggages(ticketID) {
      window.http.get(`${getHost()}/eucaturmobile/search-luggages/${ticketID}`).then((r) => {
        this.luggages = r.data;
      });
    },
    readQRCodeLuggage() {
      window.cordova.plugins.barcodeScanner.scan(
        async (result) => {
          let data = JSON.parse(result);

          if (!result) {
            mutations.openAlert({
              open: true,
              message: "Erro na Leitura",
              status: 500,
            });
            return;
          }

          let number = data.numero;
          let serie = data.serie;
          let model = data.modelo;
          let company = data.empresa;

          let params = {
            company,
            model,
            serie,
            number,
          };

          let luggage = this.luggages.find(
            (v) => v.company.trim() === params.company && v.model.trim() === params.model && v.serie.trim() === params.serie && v.number.trim() === params.number
          );

          if (luggage.luggage_delivered === "0") {
            if (luggage) {
              this.confirmDetails = luggage;
              this.confirm = true;
            } else {
              mutations.openAlert({
                open: true,
                message: "Bagagem " + params.number + " não pertence ao passageiro " + this.passengerDetails.name,
                status: 300,
              });
            }
          } else {
            mutations.openAlert({
              open: true,
              message: "Bagagem " + params.number + " com baixa no sistema",
              status: 200,
            });
          }
        },
        (error) => {
          mutations.openAlert({
            open: true,
            message: error,
            status: 500,
          });
        },
        {
          preferFrontCamera: false, // iOS and Android
          showFlipCameraButton: false, // iOS and Android
          showTorchButton: true, // iOS and Android
          torchOn: false, // Android, launch with the torch switched on (if available)
          saveHistory: true, // Android, save scan history (default false)
          prompt: "Leitura de QrCode", // Android
          resultDisplayDuration: 1500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
          formats: "QR_CODE", // default: all but PDF_417 and RSS_EXPANDED
          orientation: "portrait", // Android only (portrait|landscape), default unset so it rotates with the device
          disableAnimations: true, // iOS
          disableSuccessBeep: true, // iOS and Android
        }
      );
    },
    readQRCode() {
      window.cordova.plugins.barcodeScanner.scan(
        async (result) => {
          let data = result.text;

          if (data.match(/\?/)) {
            data = data.split("?")[1];
            let obj = URIToObject(data);
            if (this.travelDetails.passengers.find((v) => v.passage_id.toString() === obj.identification.toString())) {
              this.passengerDetails = this.travelDetails.passengers.find((v) => v.passage_id.toString() === obj.identification.toString());
              this.searchLuggages(this.passengerDetails.passage_id);
              this.dialog = true;
            } else {
              mutations.openAlert({
                open: true,
                message: "Passageiro não encontrado",
                status: 300,
              });
            }
          } else {
            data = result.text.split(",");
            if (!(data.length > 0)) {
              return;
            }

            let params = {
              company: data[0].trim(),
              model: data[1].trim(),
              serie: data[2].trim(),
              number: data[3].trim(),
            };

            window.http.get(`${getHost()}/eucaturmobile/luggage`, params).then((r) => {
              if (this.travelDetails.passengers.find((v) => v.passage_id === r.data.passage_id)) {
                this.searchLuggages(r.data.passage_id);
                this.passengerDetails = this.travelDetails.passengers.find((v) => v.passage_id === r.data.passage_id);
                this.dialog = true;
              } else {
                mutations.openAlert({
                  open: true,
                  message: "Passageiro não encontrado",
                  status: 300,
                });
              }
            });
          }
        },
        (error) => {
          mutations.openAlert({
            open: true,
            message: error,
            status: 500,
          });
        },
        {
          preferFrontCamera: false, // iOS and Android
          showFlipCameraButton: false, // iOS and Android
          showTorchButton: true, // iOS and Android
          torchOn: false, // Android, launch with the torch switched on (if available)
          saveHistory: true, // Android, save scan history (default false)
          prompt: "Leitura de QrCode", // Android
          resultDisplayDuration: 1500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
          formats: "QR_CODE", // default: all but PDF_417 and RSS_EXPANDED
          orientation: "portrait", // Android only (portrait|landscape), default unset so it rotates with the device
          disableAnimations: true, // iOS
          disableSuccessBeep: true, // iOS and Android
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
%city-circle {
  $size: 12px;

  display: block;
  width: $size;
  height: $size;
  border-radius: 50%;
}

%city-grid {
  display: grid;
  grid-column-gap: 8px;
  grid-template-columns: max-content 1fr;

  align-items: center;
  font-weight: 500;
}

.disembark {
  background-color: #ffffff;
  box-shadow: 0 3px 4px 0 #eeeff295;

  .travel__schedule {
    display: grid;
    grid-row-gap: 8px;
    grid-template-rows: max-content;
    justify-items: center;

    .schedule__info {
      display: grid;
      width: 90%;

      .info__bus {
        display: grid;
        grid-column-gap: 4px;
        grid-template-columns: repeat(2, max-content);

        place-items: center;
        margin-bottom: 8px;
        margin-left: -4px;
      }

      .info__bus--color {
        color: #172c20;
        font-weight: 600;
      }

      .circle-origin {
        background-color: #7a8583;
        @extend %city-circle;
      }

      .circle-destiny {
        background-color: #20c600;
        @extend %city-circle;
      }

      .info__origin {
        color: #707070;
        @extend %city-grid;
      }

      .info__destiny {
        color: #040006;
        @extend %city-grid;
      }
    }
  }
}

.passengers__history {
  background: #e5e5e5;
  height: 100%;
  padding: 0 4% 80px 4%;
}

.manual {
  background: #e5e5e5;
}

.manual__info {
  background-color: #ffffff;
  padding: 20px;
}

.luggage {
  background: #e5e5e5;
  padding: 20px;
  height: 80vh;

  .luggage__grid {
    display: grid;
    grid-template-columns: max-content 1fr max-content;
    padding: 20px;
    gap: 10px;
  }
}

.passengers__tips {
  font-size: 0.7rem;
  color: black;

  margin-bottom: 10px;
}

.travel__schedule {
  display: grid;
  grid-row-gap: 8px;
  grid-template-rows: max-content;
  justify-items: center;

  .schedule__info {
    display: grid;
    width: 90%;

    .info__bus {
      display: grid;
      grid-column-gap: 4px;
      grid-template-columns: repeat(2, max-content);

      place-items: center;
      margin-top: 8px;
      margin-left: -4px;
    }

    .info__bus--color {
      color: #172c20;
      font-weight: 600;
    }

    .circle-origin {
      background-color: #7a8583;
      @extend %city-circle;
    }

    .circle-destiny {
      background-color: #20c600;
      @extend %city-circle;
    }

    .info__origin {
      color: #707070;
      @extend %city-grid;
    }

    .info__destiny {
      color: #040006;
      @extend %city-grid;
    }
  }
}

$tamanho-borda: 40px;
$distancia: 0.75rem;

%row {
  @extend %flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
}

%justify-space-between {
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

%pointer {
  cursor: pointer;
}

%flex {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.onibus {
  position: relative;
  background: white;
  padding: $distancia;
  margin-top: $distancia;
  width: 100%;
  border: 2px solid #969696;
  border-top-left-radius: $tamanho-borda;
  border-top-right-radius: $tamanho-borda;

  &::before,
  &::after {
    content: "";
    position: absolute;
    width: calc(100% + 6%);
    height: 5%;
    min-height: 38px;
    background: black;
    z-index: -1;
    border-radius: 14px;
    left: -3%;
  }

  &::after {
    bottom: 2%;
  }
}

.linha {
  @extend %row;
  @extend %justify-space-between;
  width: 100%;
  margin: $distancia/2 0;
}

.poltrona {
  transform: all ease 1s;
  user-select: none;
  display: block;
  position: relative;
  font-weight: bold;
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  border-radius: 5px;

  &[situacao="true"] {
    background: #efefef;
    pointer-events: none;

    &::after {
      content: "X";
      position: absolute;
      font-size: 27px;
      max-height: 100%;
      left: 33%;
      background: #efefef;
      color: #828282;
    }
  }

  &[embarcado="false"] {
    @extend %pointer;
    background: #ffe317;
    color: #fff;
  }

  &[embarcado="true"] {
    @extend %pointer;
    background: #20c600;
    color: #fff;
  }

  &.ESPACO_MULHER::before {
    content: "\1F380";
    color: #ef83bc;
    position: absolute;
    background-color: transparent;
    bottom: -20px;
    width: 3px;
    font-weight: bold;
    left: calc(50% - 11px);
    font-size: 22px;
    z-index: 1;
  }

  &:not([numero]) {
    visibility: hidden;
  }
}
</style>
